import React, {createContext, useReducer} from 'react';

const initialState = {
    isSidebarOpened: false,
    premiumLocationFilter : 'all',
    premiumTimePeriodFilter : 12,
    statementModal : {
        isOpen : false,
        uln : '',
        id: ''
    },
    serviceTicketModal: {
        isOpen : false,
        ticketId: '',
        publicLinkId : ''
    },
    isUserOpen: false,
    roles: [],
    ulns: [],
    contact: {},
    modalMessage: "",
    refresh: null,
    isDeleteModalOpened: false,
    modalDeleteMessage: "",
    deleteContact: {},
    isSpotlightOpened: false,
    isULNDetailsEquipmentOpened: false,
    isULNDetailsCheckOpened: false,
    tableData: {},
    isRightSidebarOpened: localStorage.getItem('wms_right_siderbar_opened') === null ? true : localStorage.getItem('wms_right_siderbar_opened'),
    serviceTicketModal: {
        isOpen: false,
        ticketId: '',
        publicLinkId: ''
    },
    isSidebarOpened: false,
    isULNDetailsEquipmentOpened: false,
    isULNDetailsCheckOpened: false,
    tableData: {},
    isRightSidebarOpened: localStorage.getItem('wms_right_siderbar_opened') === null ? true : localStorage.getItem('wms_right_siderbar_opened'),
    statementModal: {
        isOpen: false,
        uln: '',
        id: ''
    },
    contactOnboardModal:{
        client_email: '',
        isError: false,
        isOpen : false,
        call_api: false,
        title: "",
        error: "",
        url: "",
        number: '',
        vendor_id: '',
        uln: ''
    },
};
const store = createContext(initialState);
const {Provider} = store;

function reducer(state, action) {
    switch (action.type) {
        case 'toggle_sidebar':
            return {
                ...state,
                isSidebarOpened : !state.isSidebarOpened
            }
        case 'premium_location_filter_change':
            return {
                ...state,
                premiumLocationFilter : action.payload
            }
        case 'premium_time_period_filter_change':
            return {
                ...state,
                premiumTimePeriodFilter : action.payload
            }
        case 'toggle_statement_modal':
            return {
                ...state,
                statementModal : {
                    isOpen : action.payload.isOpen,
                    uln : action.payload.uln,
                    id: action.payload.id
                }
            }
        case 'toggle_spotlight':
            return {
                ...state,
                isSpotlightOpened : action.payload
            }
        case 'toggle_ticket_modal' :
            return {
                ...state,
                serviceTicketModal : {
                    isOpen          : action.payload.isOpen,
                    ticketId        : action.payload.ticketId,
                    publicLinkId    : action.payload.publicLinkId
                }
        }
        case 'toggle_adduser_modal':
            
            return {
                ...state,
                isUserOpen : action.payload.isUserOpen,
                roles : action.payload.roles,
                ulns : action.payload.ulns,
                contact: action.payload?.contact || {},
                modalMessage: action.payload.modalMessage,
                refresh: action.payload?.refresh
            }
        case 'p_toggle_delete_modal':
            return{
                ...state,
                isDeleteModalOpened: action.payload.isDeleteModalOpened,
                modalDeleteMessage: action.payload.modalDeleteMessage,
                deleteContact: action.payload.deleteContact,
                contact: action.payload?.contact || {},
            }
        case 'toggle_delete_modal':
            return {
                ...state,
                isDeleteModalOpened: action.payload?.isDeleteModalOpened ?? state.isDeleteModalOpened,
                modalDeleteMessage: action.payload?.modalDeleteMessage ?? state.modalDeleteMessage,
                deleteContact: action.payload?.deleteContact ?? state.deleteContact,
                contact: action.payload?.contact ?? state.contact,
              };
        case 'toggle_uln_details_equipment':
            return {
                ...state,
                isULNDetailsEquipmentOpened : !state.isULNDetailsEquipmentOpened
            }
        case 'toggle_uln_details_check':
            return {
                ...state,
                isULNDetailsCheckOpened : !state.isULNDetailsCheckOpened,
                tableData : action.tableData
            }
        case 'toggle_right_sidebar':
            localStorage.setItem('wms_right_siderbar_opened', !JSON.parse(state.isRightSidebarOpened))
            return {
                ...state,
                isRightSidebarOpened : !state.isRightSidebarOpened
            }
        case 'toggle_contact_onboard_modal':
            return {
                ...state,
                contactOnboardModal : {
                    client_email : action.payload.client_email,
                    isError: action.payload.isError,
                    isOpen : action.payload.isOpen,
                    call_api: action.payload.call_api,
                    title: action.payload.title,
                    error: action.payload.error,
                    url: action.payload.url,
                    number: action.payload.number,
                    vendor_id: action.payload.vendor_id,
                    uln: action.payload.uln
                }
            }
        default:
            throw new Error();
    }
}

const StateProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return <Provider value={{state, dispatch}}>{children}</Provider>;
};

export {store, StateProvider}
